import { CURRENT_ADMIN_SUB_TAB, CURRENT_ADMIN_SUB_TAB_CONTAINER, CURRENT_ADMIN_TAB } from "../constants/adminSideMenuConstants";


export const sideMenuReducer = (state ={currentTab: '', currentSubTab: '', currentSubTabContainer: ''}, action) => {

    switch(action.type) {
        case CURRENT_ADMIN_TAB:
            return {
                ...state,
                currentTab: action.payload
            };
        case CURRENT_ADMIN_SUB_TAB:
            return {
                ...state,
                currentSubTab: action.payload
            };
        case CURRENT_ADMIN_SUB_TAB_CONTAINER:
            return {
                ...state,
                currentSubTabContainer: action.payload
            };
        default: 
            return state
    }
}